/**
 *
 */
he.career.upload = function () {
    var holderUpload = $(document.getElementById('holder-upload')),
        circle = holderUpload.find('.dplus-circle'),
        inputUpload = $(document.getElementById('application-file')),
        holderCopy = holderUpload.find('.holder-copy'),
        holderCopyDefault = holderCopy.clone();


    /**
     * Trigger click on plus on input field
     */
    circle.on('click', function (e) {
        // already has file
        if ($(this).hasClass('remove')) {
            // remove file
            inputUpload.val('');

            // add default copy back
            holderCopy.replaceWith(holderCopyDefault);

            // make "x" to "+"
            circle.removeClass('remove');

            return;
        }

        // add file
        inputUpload.click();
    });

    /**
     *
     */
    inputUpload.on('change', function () {
        // create element
        var span = document.createElement('span');

        // get filename and set text tp span
        span.innerText = $(this).val().replace(/^.*[\\\/]/, '');

        // add remove class
        circle.addClass('remove');

        // append filename
        holderCopy.empty().append(span);
    })
};